import React from 'react';

/** En-tête de page cohérent pour l'espace réception. */
export default function ReceptionPageHeader({ title, description, actions, badge }) {
  return (
    <header className="recv-page-header recv-no-print mb-4">
      <div className="recv-page-header__main">
        <div className="recv-page-header__text">
          {badge && <span className="recv-page-header__badge">{badge}</span>}
          <h1 className="recv-dash-page-title mb-1">{title}</h1>
          {description && <p className="recv-page-header__desc mb-0">{description}</p>}
        </div>
        {actions ? <div className="recv-page-header__actions">{actions}</div> : null}
      </div>
    </header>
  );
}
